module.exports = __webpack_public_path__ + "mobile/img/icon_add_video.d5ba5cdb.png";